import { ValueColorRule } from "../Utilities/StatusBadge";

export const CHERRY_PAY_CARD_STATUS_RULES: ValueColorRule[] = [
  { value: "Active", backgroundColor: "green.500", color: "white" },
  { value: "Closed", backgroundColor: "red.500", color: "white" },
  { backgroundColor: "orange.400", color: "black" },
];
